export const StorageEnum = Object.freeze({
    logout: "logout",
    changeRole:"change_role"
})